module.exports = __webpack_public_path__ + "static/media/AppTeaser.e1718a2a.svg";